var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconComment = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("path", { d: "M5.3,18.3c0,1.2,1,2.2,2.2,2.2h13l4.3,4.3V7.4c0-1.2-1-2.2-2.2-2.2H7.4\n\t\tc-1.2,0-2.2,1-2.2,2.2V18.3z" }),
                React.createElement("g", { transform: "translate(8.008 -23.917)" },
                    React.createElement("g", { transform: "translate(-289.5 -132.5)" },
                        React.createElement("path", { d: "M291.7,171.2h9.5" }),
                        React.createElement("path", { d: "M291.7,167.2h9.5" })))))));
});
export default IconComment;
//# sourceMappingURL=IconComment.js.map